import { render } from "./CustomOptinDialogModule.vue?vue&type=template&id=f2949d0c&scoped=true"
import script from "./CustomOptinDialogModule.vue?vue&type=script&lang=js"
export * from "./CustomOptinDialogModule.vue?vue&type=script&lang=js"

import "./CustomOptinDialogModule.vue?vue&type=style&index=0&id=f2949d0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2949d0c"]])

export default __exports__